module.exports = __webpack_public_path__ + "static/media/brokenulocklogo.b3cff15a.png";